import LinkedinIcon from 'public/assets/social/icon-linkedin.svg'

import encode from '../encodeForShare'

import css from './LinkedinShareButton.module.css'

export type LinkedinShareButtonProps = {
    url: string
}

export default function LinkedinShareButton({ url }: LinkedinShareButtonProps) {
    /* The url link need to actually work to share */
    const linkedinShareLink =
        'https://www.linkedin.com/sharing/share-offsite/?' + `url=${encode(url)}`

    return (
        <a target="_blank" rel="noopener noreferrer" href={linkedinShareLink}>
            <LinkedinIcon className={css.iconLinkedin} />
        </a>
    )
}
